export default "__VITE_ASSET__DzS4lj8C__"